import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchGroups, fetchGroupCategories, editMultiDeps, selectGroup, fetchDeps, deleteDep, fetchDepCategories, selectDep, resetCurrentGroup, editMultiGroups, deleteGroup, clearDeleteGroupStatus, resetCategory2Id } from '../../actions/products_actions';

import Groups from '../../components/Products/groups';

const groups = reduxForm({
  form: 'groups',
})(Groups);

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    deps: state.products.deps,
    groupIsLoading: state.products.groupIsLoading,
    groupError: state.products.groupError,
    currentGroup: state.products.currentGroup,
    multiIsEditing: state.products.multiGroupIsEditing,
    multiError: state.products.multiGroupEditError,
    multiEdited: state.products.multiGroupEdited,
    userPermissions: state.auth.userPermissions,
    deletingGroup: state.products.deletingGroup,
    deleteGroupSuccess: state.products.deleteGroupSuccess,
    deleteGroupError: state.products.deleteGroupError,
    selectedWarehouse: state.header.selectedWarehouse,
    selectedCompany: state.header.selectedCompany,
  };
}

export default connect(mapStateToProps, {
  fetchGroups,
  fetchDeps,
  fetchGroupCategories,
  fetchDepCategories,
  selectGroup,
  selectDep,
  resetCurrentGroup,
  editMultiDeps,
  editMultiGroups,
  deleteGroup,
  deleteDep,
  clearDeleteGroupStatus,
  resetCategory2Id,
})(groups);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/groups.jsx